import React from 'react';
import { useDroppable } from '@dnd-kit/core';
import { Fund, PipelineStage, STAGE_COLORS } from '../../types/fundraise';
import FundCard from './FundCard';

interface KanbanColumnProps {
  stage: PipelineStage;
  funds: Fund[];
  onDeleteFund?: (fund: Fund) => void;
  onFundClick?: (fund: Fund) => void;
}

const KanbanColumn: React.FC<KanbanColumnProps> = ({
  stage,
  funds,
  onDeleteFund,
  onFundClick,
}) => {
  const { setNodeRef, isOver } = useDroppable({
    id: stage.id,
    data: {
      type: 'column',
      stage,
    },
  });

  const dotColor = STAGE_COLORS[stage.color] || '#8b5cf6';

  return (
    <div className="su-kanban-column">
      <div className="su-kanban-column-header">
        <div className="su-kanban-column-title">
          <span
            className="su-kanban-column-dot"
            style={{ backgroundColor: dotColor }}
          />
          <span>{stage.name}</span>
        </div>
        <span className="su-kanban-column-count">{funds.length}</span>
      </div>
      <div
        ref={setNodeRef}
        className={`su-kanban-column-content ${isOver ? 'drag-over' : ''}`}
      >
        {funds.length === 0 ? (
          <div className="su-kanban-drop-placeholder">Drop here</div>
        ) : (
          funds.map((fund) => (
            <FundCard
              key={fund.id}
              fund={fund}
              onDelete={onDeleteFund}
              onClick={onFundClick}
            />
          ))
        )}
      </div>
    </div>
  );
};

export default KanbanColumn;
